import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {parse} from "query-string";
import Validator from "validator";
import PropTypes from "prop-types";
import { Capacitor } from "@capacitor/core";

import {Layout} from "../../shared/components/Layout";
import {InputFieldGroup} from "../../shared/components/InputFieldGroup";
import {MIN_PW_LENGTH} from "./constants";
import {login, signUp, acceptEULA} from "./actions/userAction";
import {
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from "../../shared/modules/notification/constants";
import * as notificationAction
  from "../../shared/modules/notification/actions/notificationsAction";
import {ROUTER_ROOT, ROUTER_USER_LOGIN, ROUTER_DOWNLOADS} from "../../shared/constants/routers";
import {EMAIL} from "../../shared/constants";
import version from '../../../../version.json';
import {isDeviceMobile} from "../../shared/actions";


class SignUp extends React.Component {

  static propTypes = {
    email: PropTypes.string,
    password1: PropTypes.string,
    password2: PropTypes.string,
    auth_key: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    errors: PropTypes.object,
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    firstname: "",
    lastname: "",
    email: "",
    auth_key: "",
    password1: "",
    password2: "",
    errors: {},
    isLoading: false
  };

  state = {
    firstname: "",
    lastname: "",
    email: "",
    auth_key: "",
    password1: "",
    password2: "",
    errors: {},
    isLoading: false
  };
  onSubmit = (evt) => {
    evt.preventDefault();
    this.setState({errors: {}, isLoading: true});

    acceptEULA(version);

    const {errors, isValid} = this.validateInput(this.state);
    const {email, password1, auth_key, firstname, lastname} = this.state;
    const onSuccessRegistration = () => {
      if(!Capacitor.isNative && isDeviceMobile()) this.props.history.push(ROUTER_DOWNLOADS);
      else this.props.history.push(ROUTER_ROOT);
      this.props.dispatch(notificationAction.addNotification(
        __("Registration successful"),
        NOTIFICATION_SUCCESS
      ));
    };
    const onFailedLogin = () => {
      this.props.history.push(ROUTER_USER_LOGIN);
      this.props.dispatch(notificationAction.addNotification(
        __("Login unsuccessful - Please contact %email%")
          .replace('%email%', EMAIL),
        NOTIFICATION_ERROR
      ));
    };

    if (isValid) {
      signUp(email, password1, auth_key, firstname, lastname)
        .then(() => {
          this.props.dispatch(login(email, password1))
            .then(() => {
              onSuccessRegistration();
            })
            .catch(() => {
              onFailedLogin();
            });
          }
        )
        .catch(() => {
          this.props.dispatch(notificationAction.addNotification(
            __("Registration unsuccessful - Please contact %email%")
              .replace('%email%', EMAIL),
            NOTIFICATION_ERROR
          ));
        });
    } else {
      this.setState({errors: errors, isLoading: false});
    }
  };

  validateInput(data) {
    const errors = {};
    let isValid = true;

    if (Validator.isEmpty(data.firstname)) {
      errors.firstname = __("Please make an indication.");
      isValid = false;
    }

    if (Validator.isEmpty(data.lastname)) {
      errors.lastname = __("Please make an indication.");
      isValid = false;
    }

    if (Validator.isEmpty(data.email)) {
      errors.email = __("Please enter an e-mail address.");
      isValid = false;
    } else if (!Validator.isEmail(data.email)) {
      errors.email = __("This email address is invalid.");
      isValid = false;
    }

    if (Validator.isEmpty(data.password1)) {
      errors.password1 = __("Please enter a password.");
      isValid = false;
    } else if (data.password1.length < MIN_PW_LENGTH) {
      errors.password1 = __("Your password must contain at least %count% characters.")
      .replace('%count%', MIN_PW_LENGTH);
      isValid = false;
    } else if (Validator.isEmpty(data.password2)) {
      errors.password2 = __("Please enter a password.");
      isValid = false;
    } else if (data.password1 !== data.password2) {
      errors.password1 = __("Passwords are different.");
      errors.password2 = __("Passwords are different.");
      isValid = false;
    }

    return {errors, isValid: isValid}
  }

  componentDidMount() {
    const {authmykey, mail} = parse(this.props.location.search);

    this.setState({auth_key: authmykey, email: mail || ""});
  }

  onChange = (evt) => {
    this.setState({[evt.target.name]: evt.target.value});
  };

  render() {
    const {errors, email, password1, password2, firstname, lastname} = this.state;

    return (
      <Layout
        title={__("Registration")}
        rightSpace={<Link
          to={ROUTER_USER_LOGIN}>{__("Already a member?")}</Link>}
      >
        <div id="register" className="flexBox direction-column flex">
          <form
            id="login"
            className="flexBox direction-column flex"
            onSubmit={this.onSubmit}
          >
            <InputFieldGroup
              name="firstname"
              type="text"
              placeholder={__("Firstname")}
              value={firstname}
              onChange={this.onChange}
              error={errors.firstname}
            />
            <InputFieldGroup
              name="lastname"
              type="text"
              placeholder={__("Lastname")}
              value={lastname}
              onChange={this.onChange}
              error={errors.lastname}
            />
            <InputFieldGroup
              name="email"
              type="email"
              placeholder={__("E-Mail")}
              value={email}
              onChange={this.onChange}
              error={errors.email}
            />
            <InputFieldGroup
              name="password1"
              type="password"
              placeholder={__("Password")}
              value={password1}
              onChange={this.onChange}
              error={errors.password1}
            />
            <InputFieldGroup
              name="password2"
              type="password"
              placeholder={__("Repeat Password")}
              value={password2}
              onChange={this.onChange}
              error={errors.password2}
            />
            <p className="eula">
              Indem Sie sich registrieren, stimmen Sie den <a href="https://www.media4care.de/agb/" target="_blank" rel="noopener noreferrer">Allgemeinen Geschäftsbedingungen</a> und den <a href="https://www.media4care.de/datenschutz/" target="_blank" rel="noopener noreferrer">Datenschutzrichtlinien</a> zu.
            </p>
            <button className="buttonPrimary">{__("Become a member")}</button>
          </form>
        </div>
      </Layout>
    );
  }
}

export default connect()(SignUp);
